import { Box, Checkbox, Text } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { CurrencyType } from '@tiendanube/common';
import { formatCurrency } from 'commons/utils';

interface DiscountRowProps {
  id: string;
  type: string;
  name: string;
  value: number;
  handleCheckboxChange: (
    checked: boolean,
    discountId: string,
    discountType: string,
  ) => void;
  currency: CurrencyType;
  checked?: boolean;
  disabled?: boolean;
  withCheckbox?: boolean;
}

function DiscountRow({
  id,
  type,
  name,
  value,
  handleCheckboxChange,
  currency,
  checked = false,
  disabled = false,
  withCheckbox = false,
}: Readonly<DiscountRowProps>) {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      {withCheckbox ? (
        <Checkbox
          id={id}
          name={type}
          label={name}
          checked={checked}
          disabled={disabled}
          onChange={(e) =>
            handleCheckboxChange(e.target.checked, e.target.id, e.target.name)
          }
        />
      ) : (
        <Text fontWeight="bold" color="neutral-textHigh">
          {name}
        </Text>
      )}
      <Text
        color="danger-textLow"
        textDecoration={checked ? undefined : 'line-through'}
      >
        {formatCurrency(-value, currency, language)}
      </Text>
    </Box>
  );
}

export default DiscountRow;
